import {
  BudgetApi,
  HourlyProjectInfoApi,
  ProjectApi,
  ProjectBidStatsApi,
  ProjectCollaborationApi,
  ProjectUpgradesApi,
} from '../api-typings/projects/projects';
import { transformCurrency } from '../currency/currency.transformers';
import {
  Project,
  ProjectBidStats,
  ProjectBudget,
  ProjectCollaborations,
  ProjectHourlyProjectInfo,
  ProjectUpgrades,
} from './project.model';

export function transformProject(project: ProjectApi): Project {
  if (
    !project.bid_stats ||
    !project.budget ||
    !project.currency ||
    !project.seo_url ||
    !project.time_submitted ||
    !project.type
  ) {
    throw new ReferenceError(`Missing a required project field.`);
  }

  return {
    id: project.id,

    bidPeriod: project.bidperiod,
    bidStats: transformBidStats(project.bid_stats),
    budget: transformProjectBudget(project.budget),
    currency: transformCurrency(project.currency),
    deleted: project.deleted,
    frontendProjectStatus: project.frontend_project_status,
    hideBids: project.hidebids,
    hireme: project.hireme || false,
    hourlyProjectInfo: project.hourly_project_info
      ? transformProjectHourlyProjectInfo(project.hourly_project_info)
      : undefined,
    language: project.language || 'en',
    local: project.local || false,
    ownerId: project.owner_id,
    previewDescription: project.preview_description || '',
    projectCollaborations: (project.project_collaborations || []).map(
      transformProjectCollaborations,
    ),
    seoUrl: project.seo_url,
    status: project.status,
    submitDate: project.submitdate,
    subStatus: project.sub_status,
    timeSubmitted: project.time_submitted * 1000, // Turn seconds to ms
    title: project.title,
    type: project.type,
    upgrades: project.upgrades
      ? transformProjectUpgrades(project.upgrades)
      : emptyProjectUpgrades(),
  };
}

function transformBidStats(bidStats: ProjectBidStatsApi): ProjectBidStats {
  return {
    bidCount: bidStats.bid_count || 0,
    bidAvg: bidStats.bid_avg || undefined,
  };
}

function transformProjectBudget(budget: BudgetApi): ProjectBudget {
  return {
    minimum: budget.minimum,
    maximum: budget.maximum,
    name: budget.name,
    projectType: budget.project_type,
    currencyId: budget.currency_id,
  };
}

function transformProjectHourlyProjectInfo(
  info: HourlyProjectInfoApi,
): ProjectHourlyProjectInfo {
  return {
    commitment: info.commitment,
    durationEnum: info.duration_enum,
  };
}

function transformProjectCollaborations(
  collaboration: ProjectCollaborationApi,
): ProjectCollaborations {
  return {
    context: collaboration.context,
    contextOwnerId: collaboration.context_owner_id,
    id: collaboration.id,
    permissions: collaboration.permissions || [],
    status: collaboration.status,
    timeCreated: (collaboration.time_created || 0) * 1000, // Turn seconds to ms
    userId: collaboration.user_id,
  };
}

function transformProjectUpgrades(
  upgrades: ProjectUpgradesApi,
): ProjectUpgrades {
  return {
    featured: upgrades.featured || false,
    fulltime: upgrades.fulltime || false,
    ipContract: upgrades.ip_contract || false,
    NDA: upgrades.NDA || false,
    nonCompete: upgrades.non_compete || false,
    nonpublic: upgrades.nonpublic || false,
    qualified: upgrades.qualified || false,
    sealed: upgrades.sealed || false,
    urgent: upgrades.urgent || false,
  };
}

function emptyProjectUpgrades(): ProjectUpgrades {
  return {
    featured: false,
    fulltime: false,
    ipContract: false,
    NDA: false,
    nonCompete: false,
    nonpublic: false,
    qualified: false,
    sealed: false,
    urgent: false,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/datastore/project/project.transformers.ts